import { render, staticRenderFns } from "./VxCellPaymentStatus.vue?vue&type=template&id=b1caee0a&scoped=true&"
import script from "./VxCellPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./VxCellPaymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./VxCellPaymentStatus.vue?vue&type=style&index=0&id=b1caee0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1caee0a",
  null
  
)

export default component.exports